import Moment from "moment";
import "moment/locale/ko";
import "moment/locale/ja";
import "moment/locale/ru";
import "moment/locale/zh-cn";

export function getDateString(dateString) {
    var lang_key = localStorage.getItem("language");
    // if (lang_key !== 'kp') return Moment(dateString).locale((lang_key === undefined || lang_key === null) ? 'en' : lang_key).format("LL");
    return Moment(dateString).format("YYYY.M.D.");
}

export function getDateObj(dateString) {
    var lang_key = localStorage.getItem("language");
    lang_key = lang_key === undefined || lang_key === null ? "en" : lang_key;

    var dateObj = { year: "", monthAndDate: "" };
    var formatY = "YYYY";
    var formatMD = "MMMM D";
    //
    dateObj.year = Moment(dateString).format(formatY);
    dateObj.monthAndDate = Moment(dateString).format(formatMD);

    return dateObj;
}

export function stripTag(html) {
    var tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
}

function checkBin(n) {
    return /^[01]{1,64}$/.test(n);
}
// function checkDec(n){return/^[0-9]{1,64}$/.test(n)}
function checkHex(n) {
    return /^[0-9A-Fa-f]{1,64}$/.test(n);
}

function Bin2Hex(n) {
    if (!checkBin(n)) return 0;
    return parseInt(n, 2).toString(16);
}

function Hex2Bin(n) {
    if (!checkHex(n)) return 0;
    return parseInt(n, 16).toString(2);
}

export function symbolingText(input) {
    input = stripTag(input);

    var hex_str = Bin2Hex(input);
    if (hex_str !== 0) {
        hex_str = hex_str.replace("ef8493ef8494ef8495", "eab980ec9dbcec84b1");
        hex_str = hex_str.replace("ef8496ef8497ef8498", "eab980eca095ec9dbc");
        hex_str = hex_str.replace("ef84a0ef84a1ef84a2", "eab980eca095ec9d80");
        input = Hex2Bin(hex_str);
    }

    var str_vals = [
        "위대한",
        "최고령도자",
        "령도자",
        "경애하는",
        "최고사령관",
        "위원장동지",
        "어버이수령님",
        "어버이장군님",
        "아버지장군님",
        "아버지원수님",
    ];

    for (var i = 0; i < str_vals.length; i++) {
        var reg = new RegExp(str_vals[i], "g");
        input = input.replace(reg, "<nobr>" + str_vals[i] + "</nobr>");
    }

    input = input.replace(
        new RegExp("김일성동지", "g"),
        "<nobr><b>김일성</b>동지</nobr>"
    );
    input = input.replace(
        new RegExp("김정일동지"),
        "<nobr><b>김정일</b>동지</nobr>"
    );
    input = input.replace(
        new RegExp("김정은동지", "g"),
        "<nobr><b>김정은</b>동지</nobr>"
    );

    input = input.replace(
        new RegExp("김일성장군님", "g"),
        "<nobr><b>김일성</b>장군님</nobr>"
    );
    input = input.replace(
        new RegExp("김정일장군님", "g"),
        "<nobr><b>김정일</b>장군님</nobr>"
    );
    input = input.replace(
        new RegExp("김정은장군님", "g"),
        "<nobr><b>김정은</b>장군님</nobr>"
    );
    input = input.replace(
        new RegExp("김일성장군", "g"),
        "<nobr><b>김일성</b>장군</nobr>"
    );
    input = input.replace(
        new RegExp("김정일장군", "g"),
        "<nobr><b>김정일</b>장군</nobr>"
    );
    input = input.replace(
        new RegExp("김정은장군", "g"),
        "<nobr><b>김정은</b>장군</nobr>"
    );

    input = input.replace(
        new RegExp("김일성대원수님", "g"),
        "<nobr><b>김일성</b>대원수님</nobr>"
    );
    input = input.replace(
        new RegExp("김정일대원수님", "g"),
        "<nobr><b>김정일</b>대원수님</nobr>"
    );
    input = input.replace(
        new RegExp("김정은원수님", "g"),
        "<nobr><b>김정은</b>원수님</nobr>"
    );
    input = input.replace(
        new RegExp("김일성경기장", "g"),
        "<nobr><b>김일성</b>경기장</nobr>"
    );
    input = input.replace(
        new RegExp("김일성종합대학", "g"),
        "<nobr><b>김일성</b>종합대학</nobr>"
    );
    input = input.replace(
        new RegExp("김일성광장", "g"),
        "<nobr><b>김일성</b>광장</nobr>"
    );
    input = input.replace(
        new RegExp("김일성화김정일화전시관", "g"),
        "<nobr><b>김일성</b>화</nobr><nobr><b>김정일</b>화</nobr>전시관"
    );
    input = input.replace(
        new RegExp("김일성화축전", "g"),
        "<nobr><b>김일성</b>화축전</nobr>"
    );
    input = input.replace(
        new RegExp("김정일화축전", "g"),
        "<nobr><b>김정일</b>화축전</nobr>"
    );

    // Bold Font
    input = input
        .replace(new RegExp("<b>김일성</b>", "g"), "김일성")
        .replace("김일성", "<b>김일성</b>");
    input = input
        .replace(new RegExp("<b>김정일</b>", "g"), "김정일")
        .replace("김정일", "<b>김정일</b>");
    input = input
        .replace(new RegExp("<b>김정은</b>", "g"), "김정은")
        .replace("김정은", "<b>김정은</b>");

    // input = input.replace('<nobr>위대한 수령<b>김일성</b>동지</nobr>', '위대한 수령 김일성동지').replace('위대한 수령 김일성동지', '<nobr>위대한 수령<b>김일성</b>동지</nobr>');
    // input = input.replace('<nobr>위대한 령도자<b>김정일</b>동지</nobr>', '위대한 령도자 김정일동지').replace('위대한 령도자 김정일동지', '<nobr>위대한 령도자<b>김정일</b>동지</nobr>');
    // input = input.replace('<nobr>최고령도자<b>김정은</b>동지</nobr>', '최고령도자 김정은동지').replace('최고령도자 김정은동지', '<nobr>최고령도자<b>김정은</b>동지</nobr>');
    // input = input.replace('<nobr>경애하는<b>김정은</b>동지</nobr>', '경애하는 김정은동지').replace('경애하는 김정은동지', '<nobr>경애하는<b>김정은</b>동지</nobr>');

    /* English */
    input = input.replace(
        new RegExp("Kim Il Sung", "g"),
        "<nobr><b>Kim Il Sung</b></nobr>"
    );
    input = input.replace(
        new RegExp("Kim Jong Il", "g"),
        "<nobr><b>Kim Jong Il</b></nobr>"
    );
    input = input.replace(
        new RegExp("Kim Jong Un", "g"),
        "<nobr><b>Kim Jong Un</b></nobr>"
    );

    /* Chiness */
    input = input.replace(
        new RegExp("金日成", "g"),
        "<nobr><b>金日成</b></nobr>"
    );
    input = input.replace(
        new RegExp("金正日", "g"),
        "<nobr><b>金正日</b></nobr>"
    );
    input = input.replace(
        new RegExp("金正恩", "g"),
        "<nobr><b>金正恩</b></nobr>"
    );

    /* Russian */
    input = input.replace(
        new RegExp("Ким Ир Сена", "g"),
        "<nobr><b>Ким Ир Сена</b></nobr>"
    );
    input = input.replace(
        new RegExp("Ким Ир Сену", "g"),
        "<nobr><b>Ким Ир Сену</b></nobr>"
    );
    input = input.replace(
        new RegExp("Ким Ир Сеном", "g"),
        "<nobr><b>Ким Ир Сеном</b></nobr>"
    );
    input = input.replace(
        new RegExp("Ким Ир Сене", "g"),
        "<nobr><b>Ким Ир Сене</b></nobr>"
    );
    input = input.replace(
        new RegExp("Ким Ир Сен", "g"),
        "<nobr><b>Ким Ир Сен</b></nobr>"
    );

    input = input.replace(
        new RegExp("Ким Чен Иру", "g"),
        "<nobr><b>Ким Чен Иру</b></nobr>"
    );
    input = input.replace(
        new RegExp("Ким Чен Ира", "g"),
        "<nobr><b>Ким Чен Ира</b></nobr>"
    );
    input = input.replace(
        new RegExp("Ким Чен Иром", "g"),
        "<nobr><b>Ким Чен Иром</b></nobr>"
    );
    input = input.replace(
        new RegExp("Ким Чен Ире", "g"),
        "<nobr><b>Ким Чен Ире</b></nobr>"
    );
    input = input.replace(
        new RegExp("Ким Чен Ир", "g"),
        "<nobr><b>Ким Чен Ир</b></nobr>"
    );

    input = input.replace(
        new RegExp("Ким Чен Ына", "g"),
        "<nobr><b>Ким Чен Ына</b></nobr>"
    );
    input = input.replace(
        new RegExp("Ким Чен Ыну", "g"),
        "<nobr><b>Ким Чен Ыну</b></nobr>"
    );
    input = input.replace(
        new RegExp("Ким Чен Ыном", "g"),
        "<nobr><b>Ким Чен Ыном</b></nobr>"
    );
    input = input.replace(
        new RegExp("Ким Чен Ыне", "g"),
        "<nobr><b>Ким Чен Ыне</b></nobr>"
    );
    input = input.replace(
        new RegExp("Ким Чен Ын", "g"),
        "<nobr><b>Ким Чен Ын</b></nobr>"
    );

    /* Japanese */
    input = input.replace(
        new RegExp("金日成", "g"),
        "<nobr><b>金日成</b></nobr>"
    );
    input = input.replace(
        new RegExp("金正日", "g"),
        "<nobr><b>金正日</b></nobr>"
    );
    input = input.replace(
        new RegExp("金正恩", "g"),
        "<nobr><b>金正恩</b></nobr>"
    );

    str_vals = [" 수령님", " 장군님", " 원수님", " 대원수님"];

    for (i = 0; i < str_vals.length; i++) {
        reg = new RegExp(str_vals[i], "g");
        input = input.replace(
            reg,
            " <nobr>" + str_vals[i].slice(1, str_vals[i].length) + "</nobr>"
        );
    }

    str_vals = [" 수령 "];

    for (i = 0; i < str_vals.length; i++) {
        reg = new RegExp(str_vals[i], "g");
        input = input.replace(
            reg,
            " <nobr>" +
                str_vals[i].slice(1, str_vals[i].length - 1) +
                "</nobr> "
        );
    }

    return input;
}

export function getVideoThumbFileName(videoFileName) {
    if (videoFileName) {
        return videoFileName.substr(0, videoFileName.lastIndexOf(".")) + ".jpg";
    }
    return "";
}

export function markUpString(html, search) {
    if (search === "") return html;
    const startReg = /</gi;
    const endReg = />/gi;
    let match;
    let startRegArr = Array();
    let endRegArr = Array();
    while ((match = startReg.exec(html))) {
        startRegArr.push(match.index);
    }

    while ((match = endReg.exec(html))) {
        endRegArr.push(match.index);
    }

    let showHTML = "";
    if (startReg.exec(html) == null || endReg.exec(html) == null) {
        showHTML = html.replace(
            new RegExp(search, "g"),
            "<mark>" + search + "</mark>"
        );
        // console.log(showHTML)
    } else {
        Array.from(Array(startRegArr.length)).map((value, index) => {
            if (startRegArr[index] - endRegArr[index - 1] == 1) {
                showHTML += html.substring(
                    startRegArr[index],
                    endRegArr[index] + 1
                );
            } else {
                let markString = html.substring(
                    endRegArr[index - 1] + 1,
                    startRegArr[index]
                );
                markString = markString.replace(/&nbsp;/gi, "");
                let convertMarkString = markString.replace(
                    new RegExp(search, "g"),
                    "<mark>" + search + "</mark>"
                );
                showHTML += convertMarkString;
                convertMarkString = html.substring(
                    startRegArr[index],
                    endRegArr[index] + 1
                );
                // markString = markString.replace(/&nbsp;/ig, "");
                // convertMarkString = (markString.replace(new RegExp(search, "g"), "<mark>" + search + "</mark>"))
                showHTML += convertMarkString;
            }
        });
    }
    return showHTML;
}
